import React, { useEffect, useState } from "react";
import styles from "./Slot.module.scss";
import Planning from "./components/Planning/Planning";
import Button from "../../../../components/Button/Button";
import Modal from "../../../../components/Modal/Modal";
import RepetitiveSlots from "./components/RepetitiveSlots/RepetitiveSlots";
import { fetchSlotsDetails } from "../../../../api/slot";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { usePageTitle } from "../../../../contexts/PageTitleContext";
import AppointmentList from "../Appointment/components/AppointmentList/AppointmentList";
import { fetchServicesWithRates } from "../../../../api/services";
import { fetchAppointmentsDetails } from "../../../../api/appointment";
import AddAppointment from "./components/Appointment/AddAppointment";

function Slot() {
  const [slots, setSlots] = useState([]);
  const [services, setServices] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [isSlotModalOpen, setIsSlotModalOpen] = useState(false);
  const [isAppointmentModalOpen, setIsAppointmentModalOpen] = useState(false);
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    setPageTitle("Planning");
  }, [setPageTitle]);

  const loadSlots = async () => {
    try {
      const response = await fetchSlotsDetails();
      if (response.data && response.data.length) {
        setSlots(response.data);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des créneaux : ", error);
    }
  };

  const loadAppointments = async () => {
    try {
      const response = await fetchAppointmentsDetails();
      if (response.data && response.data.length) {
        setAppointments(response.data);
      }
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des rendez-vous : ",
        error,
      );
    }
  };

  const getServices = async () => {
    try {
      const response = await fetchServicesWithRates();
      if (response.data && response.data.length) {
        setServices(response.data);
      }
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des prestations : ",
        error,
      );
    }
  };

  useEffect(() => {
    loadSlots();
    getServices();
    loadAppointments();
  }, []);

  function addSlot() {
    setIsSlotModalOpen(true);
  }

  function handleSlotsAdded() {
    loadSlots();
  }

  function addAppointment() {
    setIsAppointmentModalOpen(true);
  }

  return (
    <div className={styles.container}>
      <Planning
        slots={slots}
        allServices={services}
        onSlotsUpdated={() => {
          loadSlots();
          loadAppointments();
        }}
      />
      <div className={styles.btnContainer}>
        <Button color="var(--primary-color)" onClick={addSlot}>
          <FontAwesomeIcon icon={faPlus} className="mr-10" />
          Ajouter un créneau
        </Button>
        <Button color="var(--secondary-color)" onClick={addAppointment}>
          <FontAwesomeIcon icon={faPlus} className="mr-10" />
          Ajouter un rendez-vous
        </Button>
      </div>

      <Modal isOpen={isSlotModalOpen} onClose={() => setIsSlotModalOpen(false)}>
        {" "}
        <div className={styles.modalContent}>
          <h3>Ajouter un ou plusieurs créneaux</h3>
          <RepetitiveSlots onSlotsAdded={handleSlotsAdded} />
        </div>
      </Modal>

      <Modal
        isOpen={isAppointmentModalOpen}
        onClose={() => setIsAppointmentModalOpen(false)}
      >
        <div className={styles.modalContent}>
          <h3>Ajoutez un rendez-vous</h3>

          <AddAppointment
            onSuccess={() => {
              setIsAppointmentModalOpen(false);
              loadSlots();
              loadAppointments();
            }}
          />
        </div>
      </Modal>

      <AppointmentList appointments={appointments} />
    </div>
  );
}

export default Slot;
